/**
 * Clinical focus of Contour+ models: what each model is for, beyond its body
 * part. The catalogue's body part is too broad (breast and neck-node models
 * both report "Head and Neck" or "Abdomen and Chest"), so the agent needs
 * this extra hint to ask the right question or pick the matching model.
 *
 * DRAFT: written from the model names and catalogue labels only. Each entry
 * needs a clinician's review before clinical use. Models not listed here have
 * no focus and are treated as general-purpose (the agent asks, never guesses).
 */
const CLINICAL_FOCUS: Readonly<Record<string, readonly string[]>> = {
    breast_mr: ['breast'],
    breast2_mr: ['breast'],
    breast3_mr: ['breast'],
    brain2_mr: ['brain'],
    hnln_mr: ['neck lymph nodes'],
    fpelvist2_mr: ['female pelvis'],
    mpelvist2_mr: ['male pelvis'],
    fpelvisb_ct: ['female pelvis', 'lymph nodes'],
    mpelvisb_ct: ['male pelvis', 'lymph nodes'],
    mpelvis2b_ct: ['male pelvis'],
    pediatric_ct: ['paediatric'],
    pediatric_m_ct: ['paediatric'],
    body_organs_mr: ['whole-body organs'],
    wb_ct: ['whole-body organs'],
};

/** Clinical focus tags for a model name; empty when none is known. */
export function clinicalFocusFor(modelName: string): string[] {
    return [...(CLINICAL_FOCUS[modelName] ?? [])];
}
